import * as React from 'react'
import { LabelCardConnected } from './LabelCardConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const LabelCardExamples = () => {
  return (
    <div className="LabelCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <LabelCardConnected labelId={'124'} />
      </Provider>
    </div>
  )
}
